<template>
  <v-toolbar fixed app class="indigot darken-4k" :dark="darkmode">
    <v-toolbar-side-icon @click.stop="toggleDrawer" v-if="authenticated"></v-toolbar-side-icon>
    <!-- <v-toolbar-title>
      <router-link :to="{ name: 'welcome' }" class="white--text">{{ appName }}</router-link>
    </v-toolbar-title>&nbsp -->
    <h4>({{settings.ayt?settings.ayt.acyear.name+' - '+settings.ayt.term.name:""}})</h4>
    <v-switch style="margin-top:20px;margin-left:10px" label="Dark Mode" v-model="darkModeToggle"></v-switch>
    <v-spacer></v-spacer>

    <!-- Authenticated -->
    <template v-if="authenticated">
      <progress-bar :show="busy"></progress-bar>
      <v-btn flat :to="{ name: 'admin.dashboard',params:{frmAcct:true} }" v-if="fadm == 'true'"><v-icon>arrow_back</v-icon> Back To Admin</v-btn>
      <v-btn flat :to="{ name: 'settings.profile' }">{{ user.name }}</v-btn>
      <v-btn flat @click.prevent="logout">{{ $t('logout') }}</v-btn>
    </template>

    <!-- Guest -->
    <template v-else>
      <v-btn flat :to="{ name: 'login' }">{{ $t('login') }}</v-btn>
      <v-btn flat :to="{ name: 'register' }">{{ $t('register') }}</v-btn>
    </template>
  </v-toolbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    drawer: {
      type: Boolean,
      required: true,

    }
  },

  data: () => ({
    appName: "GPSchool", //window.config.appName,
    busy: false,
    fadm:'false'

  }),
  mounted() {
    this.$store.dispatch("settings/getAll");
    if(this.$route.params && this.$route.params.frmAdmin==true){
      localStorage.setItem("frmAdmin",true)
    }
    this.fadm =  localStorage.getItem("frmAdmin") || 'false'
  },
  computed: {
    ...mapGetters({
      user: "authUser",
      authenticated: "authCheck",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING",
      darkmode: "settings/DARKMODE"
    }),
    darkModeToggle: {
      get() {
        return this.darkmode
      },
      set(val) {
        this.$store.dispatch("settings/setDarkMode", val)
      }
    }

  },

  methods: {
    toggleDrawer() {
      this.$emit("toggleDrawer");
    },

    async logout() {
      this.busy = true;

      if (this.drawer) {
        this.toggleDrawer();
      }

      // Log out the user.
      await this.$store.dispatch("logout");
      this.busy = false;

      // Redirect to login.
      // this.$router.push({ name: 'login' }) ...old
      this.$router.push({ name: "welcome" });
    }
  }
};
</script>

<style lang="stylus" scoped>
.toolbar__title .router-link-active {
  text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ToolBar.vue